var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReenviar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_367_26515",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_367_26515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8462 16.6532L14.777 15.5995L19.377 10.9995L14.777 6.39945L15.8462 5.3457L21.5 10.9995L15.8462 16.6532ZM2.5 18.4995V14.9995C2.5 13.6866 2.9635 12.5668 3.8905 11.64C4.81733 10.713 5.93717 10.2495 7.25 10.2495H14.0693L10.2192 6.39945L11.2885 5.3457L16.9423 10.9995L11.2885 16.6532L10.2192 15.5995L14.0693 11.7495H7.25C6.3525 11.7495 5.5865 12.0668 4.952 12.7015C4.31733 13.336 4 14.102 4 14.9995V18.4995H2.5Z",
    fill: "#E7E7E7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReenviar);
export default __webpack_public_path__ + "static/media/reenviar.372b921bbdf3b35a5c1a7caa35e1374c.svg";
export { ForwardRef as ReactComponent };